import { render } from "./deleteModel.vue?vue&type=template&id=5f9091f0"
import script from "./deleteModel.vue?vue&type=script&lang=js"
export * from "./deleteModel.vue?vue&type=script&lang=js"

import "./deleteModel.vue?vue&type=style&index=0&id=5f9091f0&lang=css"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__